import React from "react";
import img404 from "../static/img/404/404.png";
import "./404.css";
import Cookies from "universal-cookie";
import ChangeLink from "../Elements/ChangeLink/ChangeLink";
import LayoutMain from "../Elements/LayoutMain/LayoutMain";
import IfYouHaveQuestions from "../Elements/LayoutMain/IfYouHaveQuestions/IfYouHaveQuestions";
import TextChange from "../../AdminPart/src/Elements/TextChange/TextChange";
const cookies = new Cookies();

let lang = 'en';
// let Language;

function HTML404 (props) {
    function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
    } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        return (
            <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['ElementMenuActive','','','','','']} Active={0} in404={true}>
                <div className="HTML404">
                    <main className="html404 StandartIn">
                        <div className="html404TopIMGOut">
                            <div className="html404TopIMG">
                                <img alt='Ifyoudontseeimages' src={img404} width={'172px'}/> <IfYouHaveQuestions lang={props.lang}/>
                            </div>
                        </div>
                        <div className="html404TopText">
                            <div className="html404TopTitleOutOut">
                                <img alt='Ifyoudontseeimages' src={img404}/>
                                <div className="html404TopTitleOut">
                                    <div className="html404TopTitle">404</div>
                                    <div className="html404TopTitle02"><TextSource ArrIndex= 'NoPage0020'>Страница не найдена</TextSource></div>
                                </div>
                            </div>
                            <div className="html404TopText">
                                <TextSource ArrIndex= 'NoPage0025'>Неправильно набран адрес, или такой страницы на сайте</TextSource>
                                <b>PROFIFOREX.COM</b>
                                <TextSource ArrIndex= 'NoPage0030'>больше не существует.</TextSource>
                                <p/>
                                <TextSource ArrIndex= 'NoPage0035'>Можно перейти на</TextSource>
                                <ChangeLink lang={props.lang} to={`/`} style={{textDecoration: 'none'}}>
                                    <TextSource ArrIndex= 'NoPage0040'>главную страницу,</TextSource>
                                </ChangeLink>
                                <TextSource ArrIndex= 'NoPage0045'>воспользоваться картой сайта, или полезными ссылками:</TextSource>
                            </div>
                            <div className="html404TopButtons">
                                <ChangeLink lang={props.lang} to={`/education/CryptoCurrency`} style={{textDecoration: 'none'}}><div className="html404TopButton"> <nobr><TextSource ArrIndex= 'NoPage0055'>Что такое криптовалюты?</TextSource></nobr></div></ChangeLink>
                                <ChangeLink lang={props.lang} to={`/education/Indicators`} style={{textDecoration: 'none'}}><div className="html404TopButton"><nobr><TextSource ArrIndex= 'NoPage0060'>Обучение: индикаторы</TextSource></nobr></div></ChangeLink>
                                <ChangeLink lang={props.lang} to={`/terms-of-trade`} style={{textDecoration: 'none'}}><div className="html404TopButton"><nobr><TextSource ArrIndex= 'NoPage0065'>Условия</TextSource></nobr></div></ChangeLink>
                            </div>
                        </div>
                    </main>
                </div>
            </LayoutMain>

        )}

export default HTML404